import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import "./ContructionMaterials.css";
import room1 from "../../images/gallery/room/room1.png";
import room2 from "../../images/gallery/room/room2.png";
import room3 from "../../images/gallery/room/room3.png";
import bathroom5 from "../../images/gallery/bathroom//bathroom5.png";
import kitchen5 from "../../images/gallery/kitchen/kitchen5.png";
import kitchen6 from "../../images/gallery/kitchen/kitchen6.png";
import kitchen7 from "../../images/gallery/kitchen/kitchen7.png";
import kitchen8 from "../../images/gallery/kitchen/kitchen8.png";
import kitchen9 from "../../images/gallery/kitchen/kitchen9.png";
import kitchen10 from "../../images/gallery/kitchen/kitchen10.png";
import kitchen11 from "../../images/gallery/kitchen/kitchen11.png";

function ContructionMaterials() {
	useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section className="construction-materials">
      <div className="construction-materials__preview">
        <h1 className="construction-materials__title">
          CONSTRUCTION MATERIALS
        </h1>
        <h2 className="construction-materials__subtitle">MIKDASH MATERIALS</h2>
      </div>
      <p className="construction-materials__text">
        We offer a wide selection of quality materials to complete your
        construction or renovation project. Our range includes everything
        necessary to create a stylish, functional, and durable interior.
      </p>
      <div className="construction-materials__photo-container">
        <div className="construction-materials__card construction-card-1">
          <h3 className="construction-materials__card-title">Tile</h3>
          <p className="construction-materials__card-text">
            A large selection of ceramic, porcelain, and mosaic tiles for walls
            and floors, perfect for bathrooms, kitchens, and other spaces
          </p>
        </div>
        <div className="construction-materials__card construction-card-2">
          <h3 className="construction-materials__card-title">
            Selection&Supply of Building Materials
          </h3>
          <p className="construction-materials__card-text">
            We provide high-quality building materials at competitive prices,
            ensuring the durability and reliability of your project
          </p>
        </div>
        <div className="construction-materials__card construction-card-3">
          <h3 className="construction-materials__card-title">
            Construction Work
          </h3>
          <p className="construction-materials__card-text">
            Professional builders and contractors from Mikdash Development will
            ensure the quality execution of all construction stages.
          </p>
        </div>
        <div className="construction-materials__card construction-card-4">
          <h3 className="construction-materials__card-title">
            Interior&Finishing
          </h3>
          <p className="construction-materials__card-text">
            We offer solutions for interior finishing and furnishing to make
            your house feel like a real home.
          </p>
        </div>
      </div>
      <div className="construction-materials__big-card construction-card-5">
        <h3 className="construction-materials__card-title">Sanitary Ware</h3>
        <p className="construction-materials__big-card-text">
          Sinks, toilets, faucets, and other elements for bathrooms and kitchens
          from leading manufacturers
        </p>
      </div>
      <div className="construction-materials__photo-container">
        <div className="construction-materials__card construction-card-6">
          <h3 className="construction-materials__card-title">
            Planning&Design
          </h3>
          <p className="construction-materials__card-text">
            Planning and Design: Our experienced architects and engineers will
            create a project that takes into account all your preferences and
            the features of the site
          </p>
        </div>
        <div className="construction-materials__card construction-card-7">
          <h3 className="construction-materials__card-title">
            Selection&Supply of Building Materials
          </h3>
          <p className="construction-materials__card-text">
            We provide high-quality building materials at competitive prices,
            ensuring the durability and reliability of your project
          </p>
        </div>
      </div>
      <div className="construction-materials__gallery">
        <h4 className="construction-materials__gallery-title">GALLERY</h4>
        <p className="construction-materials__gallery-text">
          Take a look at our gallery page to see what we offer and how our
          products will look in the interior of your kitchen, bathroom, living
          room of your home.
        </p>
        <div className="construction-materials__gallery-container">
          <img
            className="construction-materials__img"
            src={room1}
            alt="kitchen"
          />
          <img
            className="construction-materials__img"
            src={kitchen5}
            alt="bathroom"
          />
          <img
            className="construction-materials__img"
            src={bathroom5}
            alt="kitchen"
          />
          <img
            className="construction-materials__img"
            src={kitchen6}
            alt="bathroom"
          />
          <img
            className="construction-materials__img"
            src={kitchen7}
            alt="kitchen"
          />
          <img
            className="construction-materials__img"
            src={room2}
            alt="kitchen"
          />
          <img
            className="construction-materials__img"
            src={kitchen8}
            alt="kitchen"
          />
          <img
            className="construction-materials__img"
            src={kitchen9}
            alt="bathroom"
          />
        </div>
        <Link to="/gallery" className="construction-materials__button">
          Go to Gallery
        </Link>
      </div>
    </section>
  );
}

export default ContructionMaterials;
